'use strict';

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

module.exports = FsmError;

function FsmError(message, options) {
  Error.captureStackTrace(this, this.constructor);
  this.name = 'FsmError';
  this.message = message;
  this.trigger = options.name;
  this.current = options.from;

  if (options.instanceId) {
    this.instanceId = options.instanceId;
  }

  if (options.pending) {
    this.pending = options.pending;
  }
}

FsmError.prototype = Object.create(Error.prototype);
FsmError.prototype.constructor = FsmError;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(FsmError, 'FsmError', '/app/node_modules/fsm-as-promised/lib/fsm-error.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm5vZGVfbW9kdWxlcy9mc20tYXMtcHJvbWlzZWQvbGliL2ZzbS1lcnJvci5qcyJdLCJuYW1lcyI6WyJtb2R1bGUiLCJleHBvcnRzIiwiRnNtRXJyb3IiLCJtZXNzYWdlIiwib3B0aW9ucyIsIkVycm9yIiwiY2FwdHVyZVN0YWNrVHJhY2UiLCJjb25zdHJ1Y3RvciIsIm5hbWUiLCJ0cmlnZ2VyIiwiY3VycmVudCIsImZyb20iLCJpbnN0YW5jZUlkIiwicGVuZGluZyIsInByb3RvdHlwZSIsIk9iamVjdCIsImNyZWF0ZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7QUFBQUEsT0FBT0MsT0FBUCxHQUFpQkMsUUFBakI7O0FBRUEsU0FBU0EsUUFBVCxDQUFrQkMsT0FBbEIsRUFBMkJDLE9BQTNCLEVBQW9DO0FBQ2xDQyxRQUFNQyxpQkFBTixDQUF3QixJQUF4QixFQUE4QixLQUFLQyxXQUFuQztBQUNBLE9BQUtDLElBQUwsR0FBWSxVQUFaO0FBQ0EsT0FBS0wsT0FBTCxHQUFlQSxPQUFmO0FBQ0EsT0FBS00sT0FBTCxHQUFlTCxRQUFRSSxJQUF2QjtBQUNBLE9BQUtFLE9BQUwsR0FBZU4sUUFBUU8sSUFBdkI7O0FBRUEsTUFBSVAsUUFBUVEsVUFBWixFQUF3QjtBQUN0QixTQUFLQSxVQUFMLEdBQWtCUixRQUFRUSxVQUExQjtBQUNEOztBQUVELE1BQUlSLFFBQVFTLE9BQVosRUFBcUI7QUFDbkIsU0FBS0EsT0FBTCxHQUFlVCxRQUFRUyxPQUF2QjtBQUNEO0FBQ0Y7O0FBRURYLFNBQVNZLFNBQVQsR0FBcUJDLE9BQU9DLE1BQVAsQ0FBY1gsTUFBTVMsU0FBcEIsQ0FBckI7QUFDQVosU0FBU1ksU0FBVCxDQUFtQlAsV0FBbkIsR0FBaUNMLFFBQWpDOzs7Ozs7Ozs7OzBCQWpCU0EsUSIsImZpbGUiOiJmc20tZXJyb3IuanMiLCJzb3VyY2VSb290IjoiL2FwcCIsInNvdXJjZXNDb250ZW50IjpbIm1vZHVsZS5leHBvcnRzID0gRnNtRXJyb3I7XG5cbmZ1bmN0aW9uIEZzbUVycm9yKG1lc3NhZ2UsIG9wdGlvbnMpIHtcbiAgRXJyb3IuY2FwdHVyZVN0YWNrVHJhY2UodGhpcywgdGhpcy5jb25zdHJ1Y3Rvcik7XG4gIHRoaXMubmFtZSA9ICdGc21FcnJvcic7XG4gIHRoaXMubWVzc2FnZSA9IG1lc3NhZ2U7XG4gIHRoaXMudHJpZ2dlciA9IG9wdGlvbnMubmFtZTtcbiAgdGhpcy5jdXJyZW50ID0gb3B0aW9ucy5mcm9tO1xuXG4gIGlmIChvcHRpb25zLmluc3RhbmNlSWQpIHtcbiAgICB0aGlzLmluc3RhbmNlSWQgPSBvcHRpb25zLmluc3RhbmNlSWQ7XG4gIH1cblxuICBpZiAob3B0aW9ucy5wZW5kaW5nKSB7XG4gICAgdGhpcy5wZW5kaW5nID0gb3B0aW9ucy5wZW5kaW5nO1xuICB9XG59XG5cbkZzbUVycm9yLnByb3RvdHlwZSA9IE9iamVjdC5jcmVhdGUoRXJyb3IucHJvdG90eXBlKTtcbkZzbUVycm9yLnByb3RvdHlwZS5jb25zdHJ1Y3RvciA9IEZzbUVycm9yO1xuIl19